export const transformUnknownWordToCardDetails = unknownWord => {
  const { payload, translation } = unknownWord

  return {
    ...unknownWord,
    payload: payload && JSON.parse(payload),
    translation: translation && JSON.parse(translation),
  }
}
